/* Independent option selectors; only an exact catalogue variant is submitted. */
((scope) => {
  'use strict';
  const resolveVariant = (variants, values) => variants.find(variant =>
    variant.options.length === values.length && variant.options.every((value, index) => value === values[index])) || null;
  const optionState = (variants, values, index, value) => {
    const matches = variants.filter(variant => variant.options[index] === value &&
      values.slice(0, index).every((selected, previous) => variant.options[previous] === selected));
    return { exists: matches.length > 0, available: matches.some(variant => variant.available) };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { resolveVariant, optionState };
  if (!scope.document) return;
  const init = () => document.querySelectorAll('[data-option-picker]').forEach(picker => {
    if (picker.dataset.initialized) return;
    const master = picker.querySelector('[data-variant-select]');
    const controls = picker.querySelector('[data-option-controls]');
    const selects = [...picker.querySelectorAll('[data-product-option]')];
    if (!master || !controls || !selects.length) return;
    let variants;
    try { variants = JSON.parse(picker.querySelector('[data-product-variants]').textContent); }
    catch { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    picker.dataset.initialized = 'true';
    const section = picker.closest('[data-product-section]');
    const button = section?.querySelector('[data-add-button]');
    const price = section?.querySelector('[data-product-price]');
    const status = picker.querySelector('[data-option-status]');
    const selected = () => selects.map(select => select.value);
    const sync = () => {
      const values = selected();
      const variant = resolveVariant(variants, values);
      selects.forEach((select, index) => {
        [...select.options].forEach(option => {
          const state = optionState(variants, values, index, option.value);
          option.disabled = !state.exists;
          option.textContent = option.dataset.label + (state.available ? '' : ' — ' + (state.exists ? controls.dataset.soldOut : controls.dataset.unavailable));
        });
        const group = select.closest('[data-option-group]');
        const valueLabel = group.querySelector('[data-option-value-label]');
        if (valueLabel) valueLabel.textContent = select.value;
        group.querySelectorAll('[data-color-value]').forEach(swatch => {
          const state = optionState(variants, values, index, swatch.dataset.colorValue);
          swatch.setAttribute('aria-pressed', String(swatch.dataset.colorValue === select.value));
          swatch.disabled = !state.exists;
          swatch.classList.toggle('is-sold-out', !state.available);
          swatch.title = swatch.dataset.colorValue + (state.available ? '' : ' — ' + (state.exists ? controls.dataset.soldOut : controls.dataset.unavailable));
        });
      });
      master.disabled = !variant;
      master.value = variant ? String(variant.id) : '';
      if (price) price.hidden = !variant;
      if (variant) {
        master.dispatchEvent(new Event('change', { bubbles: true }));
        if (status) status.textContent = variant.available ? '' : controls.dataset.soldOut;
        const media = variant.featured_media?.id && section.querySelector('#ProductMedia-' + variant.featured_media.id);
        if (media && media.parentElement.firstElementChild !== media) media.parentElement.prepend(media);
      } else {
        if (button) { button.disabled = true; button.textContent = button.dataset.unavailableLabel; }
        if (status) status.textContent = controls.dataset.unavailable;
        const address = new URL(location.href); address.searchParams.delete('variant'); history.replaceState({}, '', address);
      }
    };
    const selectVariant = id => {
      const variant = variants.find(value => String(value.id) === String(id));
      if (!variant) return;
      selects.forEach((select, index) => { select.value = variant.options[index]; });
      sync();
    };
    selects.forEach(select => select.addEventListener('change', sync));
    picker.addEventListener('click', event => {
      const swatch = event.target.closest('[data-color-value]');
      if (!swatch || swatch.disabled) return;
      const select = swatch.closest('[data-option-group]').querySelector('[data-product-option]');
      select.value = swatch.dataset.colorValue; sync();
    });
    window.addEventListener('popstate', () => selectVariant(new URL(location.href).searchParams.get('variant')));
    controls.hidden = false;
    picker.querySelector('[data-variant-fallback]').hidden = true;
    selectVariant(master.value);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', event => document.querySelectorAll('[data-language-selector][open]').forEach(selector => { if (!selector.contains(event.target)) selector.open = false; }));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('[data-language-selector][open]').forEach(selector => { selector.open = false; selector.querySelector('summary').focus(); }); });
})(typeof window === 'undefined' ? {} : window);
